import * as React from 'react'
import { Phone, X } from 'lucide-react'
import { Alert, AlertDescription } from './alert'
import { Button } from './button'

export interface PhoneNumberAlertProps {
  /** Whether the alert should be visible */
  show: boolean
  /** Callback when the action button is clicked to open account dialog */
  onOpenAccount: () => void
  /** Whether the alert can be dismissed (optional) */
  dismissible?: boolean
  /** Callback when alert is dismissed (optional) */
  onDismiss?: () => void
  /** Custom className for styling */
  className?: string
}

export function PhoneNumberAlert({ 
  show, 
  onOpenAccount, 
  dismissible = false, 
  onDismiss,
  className = '' 
}: PhoneNumberAlertProps) {
  if (!show) return null

  return (
    <Alert className={`border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/20 ${className}`}>
      <div className="flex items-start justify-between w-full">
        <div className="flex-1">
          <AlertDescription className="text-amber-800 dark:text-amber-200">
            A phone number is needed to attend video visits with your provider. Please add your phone number to enable video consultations.
          </AlertDescription>
          <Button
            variant="outline"
            size="sm"
            onClick={onOpenAccount}
            className="mt-3 border-amber-300 text-amber-800 hover:bg-amber-100 dark:border-amber-700 dark:text-amber-200 dark:hover:bg-amber-900/20"
          >
            <Phone className="h-4 w-4 mr-2" />
            Add Phone Number
          </Button>
        </div>
        {dismissible && onDismiss && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onDismiss}
            className="h-6 w-6 p-0 text-amber-600 hover:text-amber-800 dark:text-amber-400 dark:hover:text-amber-200"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </Alert>
  )
}